import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { useAppSelector } from 'app/hooks';

// components
import ZoneContainer from 'edit/ZoneContainerConnect';
import ValueWithHeader from 'common/ValueWithHeader';

// util
import { getZonesSortingCriteria } from 'util/sort';
import { getLocaleUnitSymbol } from 'util/unit';
import { getMessage , getCropBasedMessage } from 'util/locale';
import { getActiveCropId } from 'current/currentSelectors';
import { isMultiLayerZoneGenerationEnabled } from 'manual/selectors';

const baseString = 'vra-zones-container';

const classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-zones-container': true
});
let PlantingZones = ({
  activeZoneId,
  canChooseSeedProduct,
  canSortZonesByProperties,
  script,
  scriptType,
  showLiquidApplication,
  zoneRef
}) => {
  const cropId = useAppSelector(getActiveCropId);
  const isMultiLayerEnabled = useAppSelector(isMultiLayerZoneGenerationEnabled);

  if (!script) {
    return null;
  }
  const { zones } = script;
  const sortZonesBy = getZonesSortingCriteria(canSortZonesByProperties, isMultiLayerEnabled);

  const zoneContainers = Object.values(zones)
  .sort(sortZonesBy)
  .map((zone, index) => {
    return (
      <ZoneContainer
        activeZoneId={activeZoneId}
        index={index}
        key={zone.meta.zoneId}
        script={script}
        scriptType={scriptType}
        scriptTypeIsNitrogen={false}
        zone={zone}
        zoneId={zone.meta.zoneId}
        zoneRef={zoneRef}
      />
    );
  });

  const targetYieldUnits = getLocaleUnitSymbol('area-density.yield');
  const populationUnits = getLocaleUnitSymbol('seed-density');
  const liquidUnits = getLocaleUnitSymbol('volumetric-density');

  return (
    <section className={classString} data-test-id={'planting-zones-container'}>
      <table>
        <thead>
          <tr>
            <th className={`${baseString}__table-head--zone-identifier`} />
            <th className={`${baseString}__table-head--name`}>{getMessage('zone')}</th>
            <th className={`${baseString}__table-head--target-yield`}>
              <ValueWithHeader
                header={targetYieldUnits}
                value={getMessage('target-dry-yield')}
              />
            </th>
            <th className={`${baseString}__table-head--seed-rate`}>
              <ValueWithHeader
                header={populationUnits}
                value={getMessage('rate')}
              />
            </th>
            {canChooseSeedProduct 
              && <th className={`${baseString}__table-head--product`}>
                {getCropBasedMessage({ key: 'product', cropId })}
              </th>
            }
            {
              showLiquidApplication
              && <th className={`${baseString}__table-head--fertilizer-rate`}>
                <ValueWithHeader
                  header={liquidUnits}
                  value={getMessage('liquid')}
                />
              </th>
            }
          </tr>
        </thead>
        {zoneContainers}
      </table>
      <footer />
    </section>
  );
};

PlantingZones.propTypes = {
  activeZoneId: propTypes.string.isRequired,
  canChooseSeedProduct: propTypes.bool,
  canSortZonesByProperties: propTypes.bool,
  script: propTypes.object,
  scriptType: propTypes.string.isRequired,
  showLiquidApplication: propTypes.bool,
  zoneRef: propTypes.func.isRequired
};

export default PlantingZones;
